import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import golfImage from './OgbImages/oglebay2026golf.png';
import lodgingImage from './OgbImages/oglebay2026lodging.png';

const Event_Details2026 = () => {


  const today = new Date();
  const fullDate = (today.getMonth() + 1)+ "/" + today.getDate()
  const [golfData, setGolfData] = useState([]);
  const [lodgingData, setLodgingData] = useState([]);
  const [payoutData, setPayoutData] = useState([]);
  const [payoutHead, setPayoutHead] = useState([]);

  const getEventData = async () =>{
    Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vSxJVqVGE9682VX2Cv3qxUbRMIel_FEvpO2lUkFlUbCmH0WB-V9-DisMDHKNj7QzA/pub?gid=510676449&single=true&output=csv", {
      download: true,
      header: true,
      complete: (results) => {
        
        setGolfData(results.data.slice(5,35))
        setLodgingData(results.data.slice(44,73))
      },
    },
    Papa.parse("https://docs.google.com/spreadsheets/d/e/2PACX-1vT-zogFQOw9Yo-2WHJFbppFqgudNV35b2sehEQat3m7deivgMn02qAtNkc1iapU9g/pub?gid=1833218905&single=true&output=csv", {
      download: true,
      header: true,
      complete: (results) =>{
        setPayoutData(results.data)
        setPayoutHead(results.data[0].PayoutDate)
      }
    })

    );
  }

  useEffect(() =>{
    getEventData();
  }, []);

  useEffect(() =>{
    console.log("golf data updated")
    console.log(golfData)
  }, [golfData])

  useEffect(() =>{
    console.log("payout data updated")
    console.log(payoutData)
  }, [payoutData])

  useEffect(() =>{
    console.log("lodging data updated")
    console.log(lodgingData)
  }, [lodgingData])

  return (
    <div class="mainContent" style={{padding: "0px"}}>
      <h1>2026 Event Details</h1>
      <div class="buttonNav">
        <a href="#TeeTime"><button class="detailsButton">Daily Itinerary</button></a>
        <a href="#GolfRules"><button class="detailsButton">Golf Rules</button></a>
        <a href="#GolfParticipants"><button class="detailsButton">Golf / Lodging by Day</button></a>
        <a href="#PlannedGames"><button class="detailsButton">Planned Games</button></a>
        <a href="#ProvidedList"><button class="detailsButton">What's Provided / What to Bring</button></a>
      </div>
      <div id="TeeTime" style={{paddingTop: "100px"}}>
        <div style={{paddingTop: "30px"}}>
            <h3>Daily Itinerary</h3>
            <table>
          <thead>
            <tr>
              <th colspan={3}>Daily Itinerary</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td rowspan={3}>Sunday</td>
                <td>2:20 PM - 3:10 PM</td>
                <td>Tee Times at Palmer Course</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>7:30 PM</td>
                <td>Pizza at May Cottage</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>8:00 PM</td>
                <td>Prize Money Distribution</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td rowspan={5}>Monday</td>
                <td>6:45 - 7:45 AM</td>
                <td>Breakfast at May Cottage</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td>8:45 AM</td>
                <td>Group Photo at Starter Shed</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td>8:57 - 9:51 AM</td>
                <td>Tee Times at Jones Course</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td>5:30 PM</td>
                <td>Dinner at local restaurant(s)</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td>8:00 PM</td>
                <td>Dessert / Prize Money Distribution / Hall of Fame Ceremony</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td rowspan={5}>Tuesday</td>
                <td>6:45 - 7:45 AM</td>
                <td>Breakfast at May Cottage</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>10:00 AM</td>
                <td>Group Photo at Starter Shed</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>10:10 - 11:10 AM</td>
                <td>Tee Times at Palmer Course</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>5:30 PM</td>
                <td>Dinner at local restaurant(s)</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>8:00 PM</td>
                <td>Dessert / Prize Money Distribution</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td rowspan={5}>Wednesday</td>
                <td>6:45 - 7:45 AM</td>
                <td>Breakfast at May Cottage</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td>8:55 AM</td>
                <td>Group Photo at Starter Shed</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td>9:06 - 9:51 AM</td>
                <td>Tee Times at Jones Course</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td>5:30 PM</td>
                <td>Dinner at local restaurant(s)</td>
            </tr>
            <tr style={{backgroundColor: "#afe39a99"}}>
                <td>8:00 PM</td>
                <td>Dessert / Prize Money Distribution</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td rowspan={6}>Thursday</td>
                <td>6:45 - 7:45 AM</td>
                <td>Breakfast at May Cottage</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>8:55 AM</td>
                <td>Group Photo at Starter Shed</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>9:10 - 10:00 AM</td>
                <td>Tee Times at Palmer Course</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>3:15 PM</td>
                <td>Tee Times at Jones Course for up to 8 people</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>5:30 PM</td>
                <td>Dinner at local restaurants for those not playing on Jones Course</td>
            </tr>
            <tr style={{backgroundColor: "#afdae099"}}>
                <td>8:00 PM</td>
                <td>Dessert / Prize Money Distribution</td>
            </tr>
            <tr style={{backgroundColor: "#d6b97e99"}}>
                <td rowspan={4}>Friday</td>
                <td>6:30 - 7:00 AM</td>
                <td>Breakfast at May Cottage</td>
            </tr>
            <tr style={{backgroundColor: "#d6b97e99"}}>
                <td>7:15 AM</td>
                <td>Leave for EagleSticks</td>
            </tr>
            <tr style={{backgroundColor: "#d6b97e99"}}>
                <td>9:30 - 9:57 AM</td>
                <td>Tee Times at EagleSticks</td>
            </tr>
            <tr style={{backgroundColor: "#d6b97e99"}}>
                <td>2:30 PM</td>
                <td>Prize Money Distribution</td>
            </tr>
          </tbody>
        </table>
        </div>
        <div id="GolfRules" style={{paddingTop: "100px"}}>
          <h3>Golf Rules</h3>
          <p class="overviewText">
          The entire purpose of the mbgolfers Invitational at Oglebay is to have a great time playing golf with friends. 
          To that end, we try to make the rules as generous and as fair as possible to maximize fun and minimize pain and 
          frustration while still being consistent among all our groups since massive amounts of prize money is on the line.
          </p>
          <ul class="gamesList">
            <li>
              <h5>Tees</h5>
            We recommend playing from each of the tees based on your age and handicap (see table below):
            <table>
              <thead>
                <tr>
                  <th colSpan={3}>Tees</th>
                </tr>
                <tr>
                  <th>Ages</th>
                  <th>Color</th>
                  <th>Approx. Yardage</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Age 70+ & 25+ Handicap </td>
                  <td>Red</td>
                  <td>4,600</td>
                </tr>
                <tr>
                  <td>Age 70+ & 12 - 24 Handicap </td>
                  <td>Gold</td>
                  <td>5,300</td>
                </tr>
                <tr>
                  <td>Under Age 70 <b>or</b> age 70+ & {'<'} 12 handicap </td>
                  <td>White</td>
                  <td>6,000</td>
                </tr>
              </tbody>
            </table>
            </li>
            <li>
              <h5>Winter Rules</h5>
            We will play ‘winter rules’ which allows you to ‘lift, clean, and place’ your ball no nearer the hole when in <b>your own fairway. </b> 
            If your ball is in the rough, you must play the ball as it lies unless you are in an area that is considered ‘ground under repair’.  
            If we have bad weather, we may change this rule to allow ‘lift, clean, and place’ in the rough.  <br></br><br></br>
            For those {"≥"} 70 years old and 12+ Handicap, you are allowed to ‘lift, clean, and place’ your ball everywhere (in the fairways, rough, etc. but no nearer the hole).
            </li>
            <li>
              <h5>Breakfast Ball</h5>
            Each player has one ‘breakfast ball’ that they are allowed to utilize on their first tee-shot of the day. 
            If you decide to hit a breakfast ball, you must play that ball (i.e. this is not ‘take the best shot’ of the 
            two that you hit). Also, if you don’t use your breakfast ball, it does not carry forward to another time in the round.
            </li>
            <li>
              <h5>Mulligans</h5>
            No mulligans allowed unless you are {"≥"} 70 years old and 12+ handicap. If you qualify, one (1) mulligan shot that can 
            be utilized anytime during your round… This is in addition to the Breakfast Ball rule above which can only be used on the first tee.<br></br><br></br>
            If you are under 70 years old… sorry, you have something to look forward to.
            </li>
            <li>
              <h5>Putts</h5>
              For consistency and since we have prize money on the line, putts may be given to others in your group <b>only</b> if the ball is 
              ‘<b>inside the leather</b>’ of the putter. Inside the leather for our group is defined as “from the bottom of the putter to where the grip starts” 
              which is 2-feet or less.  

            </li>
            <li>
              <h5>Sand Traps</h5>
            Since the conditions of sand traps can vary significantly, you may lift your ball, rake the area, and then place the ball in the 
            raked area to play your next shot. However, if your ball is plugged in its own pitch mark, you must play the plugged lie (fried egg) 
            without raking the trap first.<br></br><br></br>
            If you have taken two (2) shots in the same trap and are still in the bunker, you may lift the ball and place it alongside the trap 
            for your next shot… no penalty stroke (you and your playing companions have incurred enough pain).
            </li>
            <li>
              <h5>Out-of-bounds</h5>
              Play from the location that the ball went out of bounds with a 1-stroke penalty (drop within 2 club lengths) or you can 
              go back and play from the location that you last hit the ball (i.e. stroke and distance)... player choice.
            </li>
            <li>
              <h5>Water Hazard</h5>
              If there is a ‘drop-area’, take a penalty stroke and play from that location. If no ‘drop-area’, keep the point where you 
              entered the hazard and drop anywhere back on a straight-line no nearer the hole; or replay your shot from the previous location.<br></br><br></br>
              If your next shot goes into the same water hazard, you may proceed to the other side of the water hazard and play your next 
              stroke (i.e. two ball maximum in the water hazard on a hole; this is to make certain that we don’t overflow the ponds).
            </li>
            <li>
              <h5>Lost Ball</h5>
              If you lose a ball in the fairway or mowed rough due to plugging or just can’t find it after 3 minutes, you can drop and play 
              another ball from the location that you believe your ball should be with <b>no penalty stroke</b>.<br></br><br></br>
              If your ball is in the high grass that is not mowed (i.e. hillside, ravines, etc.) and you cannot find your ball, you 
              are allowed to drop a ball at the nearest point of entry and play with a <b>one stroke penalty</b>.
            </li>
            <li>
              <h5>Safety First</h5>
              We all hit shots that might end up in tough locations on steep hills, deep bunkers, on tree roots, 
              etc.… please go by the safety first motto… we don’t want anyone getting injured hitting a shot. Feel 
              free to move the ball to a safer location for your next shot. You can determine if you should take a penalty 
              stroke for the movement… <b>let your conscience be your guide</b>.
            </li>
          </ul>
        </div>
      </div>
      <div id="GolfParticipants" style={{paddingTop: "100px"}}>
        <h3>Golf Participants by Day</h3>
                <img src={golfImage} style={{width: "100%", maxWidth: "800px", display: "block", margin: "0 auto", background: "#ffffff"}}></img>
      </div>
      <div id="LodgingParticipants" style={{paddingTop: "30px"}}>
        <h3>Lodging by Day</h3>
        <img src={lodgingImage} style={{width: "100%", maxWidth: "800px", display: "block", margin: "0 auto", background: "#ffffff"}}></img>
        
      </div>
      <div id="PlannedGames" style={{paddingTop: "100px"}}>
        <h3>Planned Games</h3>
        <p class="overviewText">Planned games for 2026 and associated cost for each player / round ($10 total / round)</p>
        <ul class="gamesList">
          <li>
            <h5>Gross Skins (Gross) - $1.50 / Round</h5>
            <p>Total pot will be divided by the number of gross skins for the day.  In the event that no skins are won, each player will get their entrance fee returned.</p>
          </li>
          <li>
            <h5>Net Skins - $1.50 / Round</h5>
            <p>Total pot will be divided by the number of net skins for the day.  Handicaps are based on USGA handicap if available, league handicap, or best guess.  In the event that no skins are won, each player will get their entrance fee returned.</p>
          </li>
          <li>
            <h5>Closet to the Pin (Par 3's) - $1.00 / Round</h5>
            <p>Total pot will be divided by the winners of the closest pin shots (on the green) for each of the par 3 holes.</p>
          </li>
          <li>
            <h5>Team Game – Blind Draw - $5.00 per round</h5>
            <p>5 / 4 / or 3-man blind draw (depending on the size of our group that day); Front-nine team total, Back-nine team total, 18-hole total - $5 / round ($1.50 / player Front nine; $1.50 / player Back nine; $2 / player for Totals)  
              <br></br><br></br>Teams will be selected after the round is completed via a blind draw.  Each team will have one player 
              selected from each tier based on the final scores.  For example, if we have 24 players total for the day, we will have 
              six (6) teams that consist of 4-players on each team.  Players scores will be divided into four tiers (Tier 1 – best 6 
              scores, Tier 2 – next best 6 scores, Tier 3 – next best 6 scores, Tier 4 – lowest 6 scores).  Each team will be selected by 
              taking 1 random player out of each tier to form a team of 4 players.  <br></br><br></br>The lowest three scores of the four 
              team members will be counted for each hole.  Each team will have a total front nine score, back nine score, and total score. 
              <br></br><br></br>We will pay 1st and 2nd place winning teams for front nine, back nine, and total.<br></br><br></br>
              For days that we have 25 players, we will play 5 man teams and take the lowest 4 scores on each hole.  For days that 
              we have 21 players, we will play 3 man teams and take the lowest 2 scores on each hole.</p>
          </li>
          <li>
            <h5>Scheid Handicap - $1 / Round</h5>
            <p>
            The Scheid pot will be paid out to 3 places.  Gregg Baumgartner is the only person that understand how the Scheid works.
            </p>
          </li>
        </ul>
      </div>
      <div style={{paddingTop: "30px"}}>

      </div>
      <div id="ProvidedList" style={{paddingTop: "100px", paddingBottom: "20px"}}>
        <h3>What's Provided / What to Bring</h3>
        <ul style={{width: "60%", margin: "0 auto"}}>
          <h5>What's Provided</h5>
          <li>Breakfast will be provided each day (Monday – Friday)</li>
          <li>Supper on Sunday night only</li>
          <li>Bedding and towels</li>
          <li>Water, Arnold Palmer, Milk, Coffee, Cream, Orange Juice</li>
          <li>Pies and Ice Cream will be provided each night (for as long as it lasts)</li>
        </ul>
        <br></br><br></br>
        <ul style={{width: "60%", margin: "0 auto"}}>
          <h5>What to Bring</h5>
          <li>Snack to share</li>
          <li>Any drinks that aren't included in the "provided" list above (i.e. beer, bourbon, pop)</li>
          <li>Lawn chair (optional)</li>
          <li>Cards, cornhole, crokinole, any other games</li>
        </ul>
        <p></p>
      </div>
    </div>
  );
};
  
export default Event_Details2026;